import axios from 'axios';
import { utilityService } from '@/services/utilityService.js';
import { dateService } from '@/services/date.service.js';

export const clusterService = {
	// Returns GEO_JSON clusters based on: study, staffId, start & end dates
  	getClustersForManager,

	// Returns GEO_JSON clusters based on: study, staffId, start & end dates
  	getStaffDailySummary,

	// Returns GEO_JSON clusters based on: study, start & end dates
  	getAllStaffDailySummary,

	// Returns GEO_JSON ...
  	getEagleDay,

	// Returns GEO_JSON clusters based on: a task Id
	getClustersByTaskId,

	// Returns GEO_JSON cluster based on: cluster id
	getClusterById
};
// #region cluster

function getClustersForManager(criteria) {
	return axios.get(utilityService.buildFullyQualifiedUrl(`cluster/summary/manager/date/?format=geojson&studyCode=${criteria.study}&staffId=${criteria.id}&start=${criteria.startdate}&end=${criteria.enddate}`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function getStaffDailySummary(criteria) {	
	return axios.get(utilityService.buildFullyQualifiedUrl(`summary/find?format=geojson&studyCode=${criteria.study}&staffId=${criteria.staffId}&start=${criteria.startdate}&end=${criteria.enddate}`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function getAllStaffDailySummary(criteria) {
	return axios.get(utilityService.buildFullyQualifiedUrl(`cluster/summary/date/?format=geojson&studyCode=${criteria.study}&start=${criteria.startdate}&end=${criteria.enddate}`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function getEagleDay (criteria) {
	console.log("getEagleStartDate: ", criteria.startdate)
	console.log("getEagleEndDate: ", criteria.enddate)
	var sT = new Date(criteria.startdate).getTime()
	var eT = new Date(criteria.enddate).getTime() + 86400000
	return axios.get(utilityService.buildFullyQualifiedUrl(`task/find?staffId=${criteria.staffId}&format=GEO_JSON&studyCode=${criteria.study}&dateStart=${sT}&dateEnd=${eT}`),
	// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function getClustersByTaskId(criteria) {
	console.log("getClustersByTaskId criteria: ", criteria)
	const dateRangePair = dateService.getFormattedStartEndDatesPair(criteria.dateStart);
	console.log("dateRangePair.start", dateRangePair.start);
	console.log("dateRangePair.end", dateRangePair.end);	
	return axios.get(utilityService.buildFullyQualifiedUrl(`cluster/find?studyCode=${criteria.study}&format=GEO_JSON&staffId=${criteria.staffId}&start=${dateRangePair.start}&end=${dateRangePair.end}&types=FIELD,STOP`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

function getClusterById(criteria) {
	console.log("getClustersFromUuid criteria: ", criteria)
	return axios.get(utilityService.buildFullyQualifiedUrl(`cluster?studyCode=${criteria.study}&format=GEO_JSON&uuid=${criteria.clusterId}&types=FIELD,STOP`),
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

// missing getMoreInfo?

// #endregion analysis

// #endregion cluster


